import { render } from "./EditCountry.vue?vue&type=template&id=1342c055&scoped=true"
import script from "./EditCountry.vue?vue&type=script&lang=js"
export * from "./EditCountry.vue?vue&type=script&lang=js"

import "./EditCountry.vue?vue&type=style&index=0&id=1342c055&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1342c055"]])

export default __exports__